var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteDoc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "26px",
    height: "35px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -713 -215 )"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25.322916666666668 10  L 17.333333333333332 10  L 17.333333333333332 0.7812500000000011  C 17.58159722222222 0.9635416666666652  17.78472222222222 1.1458333333333293  17.942708333333332 1.328125000000001  L 24.848958333333332 9.296875  C 25.006944444444446 9.479166666666664  25.164930555555557 9.713541666666664  25.322916666666668 10  Z M 15 0  L 15 10.625000000000002  C 15.166666666666668 11.145833333333329  15.324652777777777 11.588541666666666  15.640625 11.953124999999998  C 15.956597222222223 12.31770833333333  16.34027777777778 12.499999999999998  16.791666666666668 12.499999999999998  L 26 12.499999999999998  L 26 33.125  C 26 33.645833333333336  25.842013888888886 34.088541666666664  25.526041666666668 34.453125  C 25.210069444444446 34.817708333333336  24.82638888888889 35  24.375 35  L 1.625 35  C 1.1736111111111112 35  0.7899305555555556 34.817708333333336  0.47395833333333337 34.453125  C 0.1579861111111111 34.088541666666664  0 33.645833333333336  0 33.125  L 0 1.875000000000001  C 0 1.3541666666666656  0.1579861111111111 0.911458333333332  0.47395833333333337 0.546875  C 0.7899305555555556 0.18229166666666796  1.1736111111111112 0  1.625 0  L 15 0  Z ",
    fillRule: "nonzero",
    fill: "#f2f2f2",
    stroke: "none",
    transform: "matrix(1 0 0 1 713 215 )"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteDoc);
export default __webpack_public_path__ + "static/media/whiteDoc.640bed47215030b23b866880ad2fee6b.svg";
export { ForwardRef as ReactComponent };